export enum SMTEvents {
  addCommentButtonClicked = 'Add SMT Entry Comment Button Clicked',
  addCommentCanceled = 'Add SMT Entry Comment Canceled',
  addCommentConfirmed = 'Add SMT Entry Comment Confirmed',
  addEntryButtonClicked = 'Add SMT Entry Button Clicked',
  addEntryCanceled = 'Add SMT Entry Canceled',
  addEntryConfirmed = 'Add SMT Entry Confirmed',
  dailyLogAccordionClicked = 'SMT Daily Log Accordion Clicked',
  datePickerDateSelected = 'SMT Date Picker Date Selected',
  datePickerMonthChanged = 'SMT Date Picker Month Changed',
  deleteEntryButtonClicked = 'Delete SMT Entry Button Clicked',
  deleteEntryCanceled = 'Delete SMT Entry Canceled',
  deleteEntryConfirmed = 'Delete SMT Entry Confirmed',
  discardEntryChangesBackClick = 'SMT Discard Entry Changes Back Click',
  discardEntryChangesConfirmClick = 'SMT Discard Entry Changes Confirm Click',
  discardEntryChangesDismissClick = 'SMT Discard Entry Changes Dismiss Click',
  discardEntryChangesModalView = 'SMT Discard Entry Changes Modal View',
  editEntryButtonClicked = 'Edit SMT Entry Button Clicked',
  editEntryCanceled = 'Edit SMT Entry Canceled',
  editEntryConfirmed = 'Edit SMT Entry Confirmed',
  entryKebabMenuClicked = 'SMT Entry Kebab Menu Clicked',
  goToCarePlanLinkClicked = 'Go To Care Plan Link Clicked',
  imageClicked = 'SMT Image Clicked',
  imageModalClosed = 'SMT Image Modal Closed',
  imageZoomIn = 'SMT Image Zoom In',
  imageZoomOut = 'SMT Image Zoom Out',
  imageZoomReset = 'SMT Image Zoom Reset',
  journalTabButtonClicked = 'Journal Tab Button Clicked',
  patientToggleClicked = 'Patient Toggle Clicked',
  updatePermissionsSelected = 'Update SMT Permissions Selected',
}
